export enum DropdownDirection {
    'Above' = '-sh-open-above-push-right',
    'Below' = '-sh-open-below-push-right',
    'BelowLeft' = '-sh-open-below-push-left',
    'AboveLeft' = '-sh-open-above-push-left'
}
